import { caPostalCode, isLocaleCA, usPostalCode } from '@libs/core';

export type AlertTextType = {
    title: string;
    text: string;
    link?: string;
    linkText?: string;
};

const GENERAL_ALERT: AlertTextType = {
    title: 'No locations found',
    text: 'Please try again',
};

export const getAlertText = (searchText: string): AlertTextType => {
    const isCanadaLocale = isLocaleCA();

    if (searchText === '') {
        return GENERAL_ALERT;
    }

    // check if usser is trying to search an US postal code on the .ca site
    if (isCanadaLocale && usPostalCode(searchText)) {
        return {
            title: 'Searching for a store in the United States?',
            text: 'Please go to ',
            link: 'https://www.petsmart.com',
            linkText: 'petsmart.com',
        };
    }

    // check if user is trying to search Canadian postal codes on the .com site
    if (!isCanadaLocale && caPostalCode(searchText)) {
        return {
            title: 'Searching for a store in Canada?',
            text: 'Please go to ',
            link: 'https://www.petsmart.ca',
            linkText: 'petsmart.ca',
        };
    }

    return GENERAL_ALERT;
};
